import React from 'react';
import CloseTransaction from '../../common/poppers/CloseTransaction';
// import MatcherForTransaction from '../../common/poppers/MatcherForTransaction';
import BankRow from './BankRow';
import _ from 'lodash'
import CloseAndLinkToPartner from './CloseAndLinkToPartner';
import ReopenAndUnlinkPartner from './ReopenAndUnlinkPartner';

export const bankActionItems = [
    {
    //     dataDialog: "transaction-dialog",
    //     title: "Linkel",
    //     dialogTitle: "Linkel",
    //     canShow: (row) => "MATCH_FOUND" === row.state,
    //     actionComponent: (props, close) => <MatcherForTransaction {...props} close={close} row={props.row} billtype={props.tabletype} />
    // }, {
        dataDialog: "close-dialog",
        title: "Lezárás",
        dialogTitle: "Tranzakció Lezárása",
        canShow: (row) => "COMPLETE" !== row.state && "CLOSED" !== row.state,
        actionComponent: (props, close) => <CloseTransaction {...props} close={close} path={'/api/manualclose/transaction'} isClose={true} confirm={"Biztos hogy le szeretnéd zárni?"} comp={<BankRow {...props} />} />
    }, {
        dataDialog: "close-dialog",
        title: "Újranyitás",
        dialogTitle: "Tranzakció Újranyitása",
        canShow: (row) => "CLOSED" === row.state && !row.linkedPartnerId,
        actionComponent: (props, close) => <CloseTransaction {...props} close={close} path={'/api/manualclose/transaction'} isClose={false} confirm={"Biztos hogy újra szeretnéd nyitni?"} comp={<BankRow {...props} />} />
    }, {
        dataDialog: "link-partner-dialog",
        title: "Lezárás és partnerhez csatolás",
        dialogTitle: "Lezárás és partnerhez  csatolás",
        canShow: (row) => "CLOSED" !== row.state && "COMPLETE" !== row.state && row.linked.map && _.isEmpty(row.linked.map) && !row.linkedPartnerId,
        actionComponent: (props, close) => <CloseAndLinkToPartner {...props} close={close} path={'/api/bank/closeandlinkpartner'} comp={<BankRow {...props} />} />
    }, {
        dataDialog: "link-partner-dialog",
        title: "Újranyitás és partner törlése",
        dialogTitle: "Újranyitás és partner törlése",
        canShow: (row) => "CLOSED" === row.state && row.linkedPartnerId,
        actionComponent: (props, close) => <ReopenAndUnlinkPartner {...props} close={close} path={'/api/bank/reopenAndUnlinkPartner'} comp={<BankRow {...props} />} />
    }
// {
//     dataDialog: "modify-dialog",
//     title: "Módosít",
//     dialogTitle: "Számla módosítása",
//     actionComponent: (props, close) => <ModifyIncoming  {...props} close={close} />
// },
//  {
//         dataDialog: "delete-dialog",
//         title: "Törlés",
//         dialogTitle: "Számla törlése",
//         actionComponent: (props, close) => <DeleteObject {...props} close={close} path={'/api/incomingbill'} confirm={"Biztos hogy törölni szeretnéd?"} comp={<IncomingBillRow {...props} />} />
//     },
// {
]